export default "__VITE_ASSET__Cb_tN6VV__"